import styled from '@emotion/styled';

export const EmployeeAppCard = styled('div')<{
  noRoundBorders?: boolean;
  hoverEffect?: boolean;
  highlight?: boolean;

  noTopBorder?: boolean;
  noBottomBorder?: boolean;
  fullHeight?: boolean;
  cursorPointer?: boolean;
  padding?: number;
}>((p) => ({
  border: `1px ${p.theme.custom.colors.gray.w200} solid`,
  borderRadius: p.theme.custom.border.radius(p.noRoundBorders ? 0 : 2),
  backgroundColor: p.highlight ? p.theme.custom.colors.gray.w200 : 'white',
  padding: p.theme.spacing(p.padding ?? 2),
  width: '100%',
  height: p.fullHeight ? '100%' : undefined,
  cursor: p.onClick || p.cursorPointer ? 'pointer' : 'default',

  ...(p.hoverEffect
    ? {
        ':hover': {
          backgroundColor: p.theme.custom.colors.gray.w100
        }
      }
    : {}),
  ...(p.noTopBorder
    ? {
        borderTop: 'none'
      }
    : {}),
  ...(p.noBottomBorder
    ? {
        borderBottom: 'none'
      }
    : {})
}));
